export default __webpack_public_path__ + "static/media/star.97d29376.png";